import { useCallback, useRef } from 'react';
import type { FlatListProps } from 'react-native';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import type { ListItem } from '../types';

export const useLogDisplayGoods = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const loggedSnoRef = useRef<Set<number>>(new Set());

  return useCallback<
    NonNullable<FlatListProps<ListItem>['onViewableItemsChanged']>
  >(
    ({ viewableItems }) => {
      viewableItems.forEach(({ item, isViewable }) => {
        if (!isViewable || item.type !== 'goodsRow') return;
        item.cells.forEach(cell => {
          if (cell.type === 'placeholder') return;
          if (loggedSnoRef.current.has(cell.data.sno)) return;
          loggedSnoRef.current.add(cell.data.sno);

          logAnalyticsEvent({
            channel: ['amplitude', 'ablylog', 'firebase'],
            name: 'DISPLAY_GOODS',
            analytics: cell.data.logging.analytics,
            ably_only_log: cell.data.logging.ably_only_log,
          });

          if (isNotNil(cell.data.item.ad)) {
            bridge.logAdEvent({
              action: AdAction.DISPLAY,
              ad: cell.data.item.ad,
            });
          }
        });
      });
    },
    [logAnalyticsEvent],
  );
};
